import { toQuery } from 'src/utils/utils';

import { handleResponse } from '../utils/auth-header';
import axios, { axiosOption } from '../utils/axios';

export const Goicuoc5gService = {
  
  homepageList: (payload) => {
    return axios.post(`/api/v1/goicuoc5g/homepageList`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageFindOne: (id) => {
    return axios.get(`/api/v1/goicuoc5g/homepageFindOne/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageLimitList: (payload) => {
    return axios.post(`/api/v1/goicuoc5g/homepageLimitList`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  homepageLimitFindOne: (id) => {
    return axios.get(`/api/v1/goicuoc5g/homepageLimitFindOne/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
  
  approve: (id, payload) => {
    return axios.put(`/api/v1/goicuoc5g/approve/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  setTrangThai: (id, payload) => {
    return axios.put(`/api/v1/goicuoc5g/setTrangThai/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  create: (payload) => {
    return axios.post('/api/v1/goicuoc5g', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  save: (payload) => {
    return axios.post('/api/v1/goicuoc5g/import', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  update: (id, payload) => {
    return axios.put(`/api/v1/goicuoc5g/${id}`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      return handleResponse(error.response)
    })
  },

  findAll: (page, count, payload) => {
    let url = `/api/v1/goicuoc5g?page=${page}&count=${count}`;

    if (payload.name) {
      url += `&name=${payload.name}`
    };

    if (typeof payload.price_min != 'undefined') {
      url += `&price_min=${payload.price_min}`
    };

    if (typeof payload.price_max != 'undefined') {
      url += `&price_max=${payload.price_max}`
    };

    if (payload.operator) {
      url += `&operator=${payload.operator}`
    };

    if (payload.number_type) {
      url += `&number_type=${payload.number_type}`
    };

    if (payload.tam_dung) {
        url += `&tam_dung=${payload.tam_dung}`
      };

    if (payload.time_by_day_min) {
      url += `&time_by_day_min=${payload.time_by_day_min}`
    };
    
    if (payload.time_by_day_max) {
      url += `&time_by_day_max=${payload.time_by_day_max}`
    };
    
    return axios.get(url, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findAssign: (page, count) => {
    return axios.get(`/api/v1/goicuoc5g/assign?page=${page}&count=${count}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  find: (id) => {
    return axios.get(`/api/v1/goicuoc5g/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  findPosition: (position) => {
    return axios.get(`/api/v1/goicuoc5g/findPosition/${position}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  countAssign: () => {
    return axios.get(`/api/v1/goicuoc5g/count-assign`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  delete: (id) => {
    return axios.delete(`/api/v1/goicuoc5g/${id}`, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  assign: (payload) => {
    return axios.post(`/api/v1/goicuoc5g/assign`, payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },

  sendOrder: (payload) => {
    return axios.post('/api/v1/goicuoc5g/sendOrder', payload, axiosOption()).then((rs) => {
      return handleResponse(rs)
    }).catch((error) => {
      throw handleResponse(error.response)
    })
  },
}